/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthorizationStatus,
  HistoryResponse,
  SortOrder,
} from '../models';
import {
    AuthorizationStatusFromJSON,
    AuthorizationStatusToJSON,
    HistoryResponseFromJSON,
    HistoryResponseToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models';

export interface GetGroupSettingsHistoryRequest {
    authorization?: string;
    onBehalfOf?: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortOrder?: SortOrder;
}

/**
 * 
 */
export class HistoryApi extends runtime.BaseAPI {

    /**
     * Returns the audit log rows backing the \"View history of group and setting changes\" report. The underlying CM query is limited to the last 30 days and to 1000 most recent entries.
     * Gets the history of group and setting changes made by the admin\'s agency.
     */
    async getGroupSettingsHistoryRaw(requestParameters: GetGroupSettingsHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HistoryResponse>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.sortOrder !== undefined) {
            queryParameters['sortOrder'] = requestParameters.sortOrder;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.onBehalfOf !== undefined && requestParameters.onBehalfOf !== null) {
            headerParameters['On-Behalf-Of'] = String(requestParameters.onBehalfOf);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/history/group-settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HistoryResponseFromJSON(jsonValue));
    }

    /**
     * Returns the audit log rows backing the \"View history of group and setting changes\" report. The underlying CM query is limited to the last 30 days and to 1000 most recent entries.
     * Gets the history of group and setting changes made by the admin\'s agency.
     */
    async getGroupSettingsHistory(requestParameters: GetGroupSettingsHistoryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HistoryResponse> {
        const response = await this.getGroupSettingsHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
